import React, { useCallback, useEffect, useState } from 'react';
import AddTaskDialogView from '../view/AddTaskDialogView';
import getUTCNoonForDate from '../../../utils/getUTCNoonForDate';
import { priorityOptions } from './TasksTabEngine';

const AddTaskDialogEngine = ({ closeAddTaskDialog = () => {}, open }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [
    isUnsavedChangesWarningDialogOpen,
    setIsUnsavedChangesWarningDialogOpen
  ] = useState(false);
  const [taskTitle, setTaskTitle] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [taskDueDate, setTaskDueDate] = useState(null);
  const [priority, setPriority] = useState('medium');
  const [existingFiles, setExistingFiles] = useState([]);

  useEffect(() => {
    if (open === false) {
      clearForm();
    }
  }, [open]);

  const clearForm = () => {
    setTaskTitle('');
    setTaskDescription('');
    setSelectedUser(null);
    setTaskDueDate(null);
    setPriority('medium');
    setExistingFiles([]);
    setIsDirty(false);
  };
  const handleClose = () => {
    if (isDirty) {
      setIsUnsavedChangesWarningDialogOpen(true);
    } else {
      closeAddTaskDialog(null);
    }
  };
  const onConfirmLoseChangesDialog = () => {
    setIsUnsavedChangesWarningDialogOpen(false);
    closeAddTaskDialog(null);
  };
  const handleConfirm = () => {
    closeAddTaskDialog({
      status: 'assigned',
      title: taskTitle,
      description: taskDescription,
      assigneeId: selectedUser?.value || '',
      assigneeDisplay: selectedUser?.label || '',
      dueDate: taskDueDate,
      priority,
      existingFiles
    });
  };
  const onChangeSelectedUser = val => {
    setSelectedUser(val);
    setIsDirty(true);
  };
  const onChangeDate = dateValue => {
    const chosenDate = dateValue ? getUTCNoonForDate(dateValue) : null;
    setTaskDueDate(chosenDate);
    setIsDirty(true);
  };
  const onChangePriority = e => {
    const val = e.target.value;
    setPriority(val);
    setIsDirty(true);
  };
  const onFileDropped = useCallback(
    file => {
      const id = file.name;
      file.id = encodeURIComponent(id);
      const newExistingFiles = [...existingFiles, file];
      setExistingFiles(newExistingFiles);
      setIsDirty(true);
    },
    [existingFiles]
  );

  const onChangeTaskTitle = e => {
    setTaskTitle(e.target.value);
    setIsDirty(true);
  };

  const onChangeTaskDescription = e => {
    setTaskDescription(e.target.value);
    setIsDirty(true);
  };

  const viewProps = {
    buttons: [
      {
        text: 'dialog.cancel',
        variant: 'outlined',
        'data-testid': 'cancel-add-task'
      },
      {
        text: 'tasks.dialog.create_task',
        disabled: !taskTitle || !selectedUser || !taskDueDate,
        onClick: 'confirm',
        'data-testid': 'confirm-add-task'
      }
    ],
    existingFiles,
    isUnsavedChangesWarningDialogOpen,
    setIsUnsavedChangesWarningDialogOpen,
    onConfirmLoseChangesDialog,
    onChangeDate,
    onFileDropped,
    open,
    priorityOptions,
    handleClose,
    handleConfirm,
    onChangeSelectedUser,
    onChangePriority,
    priority,
    selectedUser,
    setExistingFiles,
    taskDueDate,
    taskTitle,
    taskDescription,
    onChangeTaskTitle,
    onChangeTaskDescription
  };

  return <AddTaskDialogView {...viewProps} />;
};

export default AddTaskDialogEngine;
